/**
 * Utility functions for detail panel calculations
 */

/**
 * Get the detail panel height based on screen size
 * @returns The height of the detail panel in pixels
 */
export const getDetailPanelHeight = (): number => {
  // Use consistent heights across the application
  // Desktop/tablet: 250px, Mobile: 230px
  return window.innerWidth >= 600 ? 250 : 230;
};

/**
 * Get the detail panel height for map center shifting (slightly larger on mobile for better UX)
 * @returns The height to use for map center calculations in pixels
 */
export const getDetailPanelHeightForMapShift = (): number => {
  // Slightly larger on mobile to account for touch interactions and better spacing
  return window.innerWidth >= 600 ? 250 : 280;
};
